import { cloneDeep } from 'lodash-es';

// @ts-expect-error: remove this comment to improve type-safety
export default function resetStore({ store }) {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => store.$patch(cloneDeep(initialState));
}
